var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Formatting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2484 11.8C15.7381 11.5018 16.1513 11.0934 16.4551 10.6073C16.7589 10.1212 16.945 9.57077 16.9984 9C17.0077 8.48388 16.9152 7.971 16.7262 7.49063C16.5373 7.01027 16.2555 6.57184 15.8971 6.20039C15.5386 5.82894 15.1105 5.53174 14.6372 5.32578C14.1638 5.11981 13.6546 5.00911 13.1384 5H6.64844V19H13.6484C14.1396 18.9948 14.6249 18.8929 15.0767 18.7001C15.5284 18.5073 15.9378 18.2274 16.2814 17.8764C16.6249 17.5253 16.896 17.1101 17.0791 16.6543C17.2622 16.1985 17.3537 15.7112 17.3484 15.22V15.1C17.3488 14.4071 17.1514 13.7285 16.7794 13.144C16.4074 12.5594 15.8763 12.0931 15.2484 11.8ZM8.64844 7H12.8484C13.2746 6.98681 13.6946 7.10428 14.0521 7.33665C14.4096 7.56902 14.6875 7.90517 14.8484 8.3C15.0113 8.82779 14.9586 9.39859 14.7019 9.88765C14.4452 10.3767 14.0053 10.7443 13.4784 10.91C13.2738 10.97 13.0617 11.0003 12.8484 11H8.64844V7ZM13.2484 17H8.64844V13H13.2484C13.6746 12.9868 14.0946 13.1043 14.4521 13.3367C14.8096 13.569 15.0875 13.9052 15.2484 14.3C15.4113 14.8278 15.3586 15.3986 15.1019 15.8877C14.8452 16.3767 14.4053 16.7443 13.8784 16.91C13.6738 16.97 13.4617 17.0003 13.2484 17Z",
    fill: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.c0877b9995636604a85ad7f4de0352b8.svg";
export { ForwardRef as ReactComponent };